/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-03-08 10:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Card, Button, SkeletonBodyText, Heading } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { routes } from 'src/routes';
import history from 'src/routes/history';
import * as themeSetupV3Action from 'actions/theme-setup-v3-actions';
import noThemeStatus from 'src/assets/images/dashboard-v3/no-theme-status.png';
import notLiveThemeStatus from 'src/assets/images/dashboard-v3/not-live-theme.png';
import successThemeStatus from 'src/assets/images/dashboard-v3/theme-status-success.png';

type Props = {
  loading: boolean,
  themes: Array<{ role: string }>,
  getMainThemeSetupStatus: () => void
};

type State = {
  imageLoaded: boolean
};

// Get color and image for each live theme status
const defineTheme = {
  wellInstall: {
    color: '#008060',
    image: successThemeStatus
  },
  noTheme: {
    color: '#D72C0D',
    image: noThemeStatus
  },
  notLive: {
    color: '#F48D32',
    image: notLiveThemeStatus
  },
  loading: ''
};

type ComposedProps = Props & WithI18nProps;
class ThemeSetupStatus extends Component<ComposedProps, State> {
  state = {
    imageLoaded: false
  };

  componentDidMount() {
    // Get main theme setup status
    this.props.getMainThemeSetupStatus();
  }

  render() {
    const { status, i18n } = this.props;
    const { imageLoaded } = this.state;

    return (
      <div className="BC-ThemeSetup__DashboardV3">
        <Card>
          <Card.Section>
            <div className="layoutCols">
              <div className="firstCol">
                <Heading>{i18n.translate('AdminHTML.DashboardV3.ThemeSetupStatus.title')}</Heading>
                {/* {getLiveThemeStatusHtml(status, i18n)} */}
                {status === 'loading' ? (
                  <SkeletonBodyText lines={5} />
                ) : (
                  <>
                    <div className="content-status">
                      {i18n.translate(`AdminHTML.DashboardV3.ThemeSetupStatus.${status}`, {
                        t1: (
                          <span style={{ color: defineTheme[status].color, fontWeight: '600' }}>
                            {i18n.translate(`AdminHTML.DashboardV3.ThemeSetupStatus.${status}_t1`)}
                          </span>
                        )
                      })}
                    </div>
                    <Button
                      onClick={() => {
                        history.push(routes.themeSetup.view());
                      }}>
                      {i18n.translate('AdminHTML.DashboardV3.ThemeSetupStatus.buttonChildren')}
                    </Button>
                  </>
                )}
              </div>
              <div className="secondCol">
                <div>
                  <img
                    src={defineTheme[status].image}
                    alt=""
                    style={{ position: imageLoaded ? undefined : 'absolute' }}
                    onLoad={() => {
                      this.setState({ imageLoaded: true });
                    }}
                  />
                </div>
              </div>
            </div>
          </Card.Section>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  status: _.get(state.themeSetupV3, 'mainThemeSetupStatus', 'noTheme')
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  getMainThemeSetupStatus: () => dispatch(themeSetupV3Action.getMainThemeSetupStatus(ownProps.i18n))
});

export default withI18n()(connect(mapStateToProps, mapDispatchToProps)(ThemeSetupStatus));
